import {
  type LoadExchangeRateInput,
  useQuery,
  useExchangeRatesForLoad as useSharedExchangeRatesForLoad,
} from '@fv/client-core'
import type { ExchangeRateMap } from '@fv/models'

import { carrierFetch } from '@/utils/carrierFetch'

export function useExchangeRates(enabled = true, date?: Date | string) {
  const dateStr = date ? new Date(date).toISOString() : undefined
  return useQuery<ExchangeRateMap>(
    ['exchange-rates', dateStr],
    () =>
      carrierFetch<ExchangeRateMap>('/exchange-rates', {
        query: { ...(dateStr && { date: dateStr }) },
      }),
    {
      enabled,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 60,
    },
  )
}

export function useExchangeRatesForLoad(
  load: LoadExchangeRateInput | undefined,
  enabled: boolean,
): ExchangeRateMap {
  return useSharedExchangeRatesForLoad(load, enabled, useExchangeRates)
}
